import { status } from '../../config.ts'
import {
  activitySummary,
  clientDetail,
  clientPersonalData,
  clientsPage1,
  getCreditFromBirthday,
  modificationHistoryPage1,
  paymentTypes,
  personalDocs,
  transactionSearchClient,
  transactionsPage1,
  verifyEmailCode,
  wallet
} from './data.ts'
import { wait } from '@/__mocks__/util/async.ts'
import { articlesPage1 } from '@/__mocks__/modules/articles/data.ts'
import {
  isCoordsOnlyLegacyLocationMock,
  isLegacyLocationMock
} from '@/__mocks__/util/legacyLocation.ts'

export default [
  {
    method: 'GET',
    path: '/clients?limit=20',
    reply: async () => {
      await wait()
      return [status.ok, clientsPage1]
    }
  },
  {
    method: 'GET',
    path: '/clients?search=juan',
    reply: async () => {
      await wait()
      return [status.ok, clientsPage1]
    }
  },
  {
    method: 'GET',
    path: '/clients/2',
    reply: async () => {
      await wait()
      return [status.ok, clientDetail]
    }
  },
  {
    method: 'POST',
    path: '/client',
    reply: async () => {
      await wait()
      return [status.ok, { data: { id: '2' } }]
    }
  },
  {
    method: 'PUT',
    path: '/clients/2',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'POST',
    path: '/client-editing-requests',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'DELETE',
    path: '/clients/2',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'PATCH',
    path: '/clients/2',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'PATCH',
    path: '/clients/2/status',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'PATCH',
    path: '/clients/2/status',
    reply: async () => {
      await wait()
      return [status.error]
    }
  },
  {
    method: 'GET',
    path: '/clients/2/credits?limit=20',
    reply: async () => {
      await wait()
      return [status.ok, articlesPage1]
    }
  },
  {
    method: 'GET',
    path: '/credits?limit=20&page=1&search=123456',
    reply: async () => {
      await wait()
      return [status.ok, clientsPage1]
    }
  },
  {
    method: 'GET',
    path: '/credits?limit=20&page=1&search=5404264',
    reply: async () => {
      await wait()
      return [status.ok, clientsPage1]
    }
  },
  {
    method: 'POST',
    path: '/clients/send-email',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'POST',
    path: '/clients/exist-email?clientId=2',
    reply: async () => {
      await wait()
      return [status.ok, { data: { exist: false } }]
    }
  },
  {
    method: 'POST',
    path: '/clients/verify-email',
    reply: async () => {
      await wait()
      return [status.ok, verifyEmailCode]
    }
  },
  {
    method: 'POST',
    path: '/clients/2/send-sms',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'POST',
    path: '/clients/2/send-sms',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'POST',
    path: '/clients/exist-phone?clientId=2',
    reply: async () => {
      await wait()
      return [status.ok, { data: { exist: false } }]
    }
  },
  {
    method: 'POST',
    path: '/clients/exist-document-number?clientId=2',
    reply: async () => {
      await wait()
      return [status.ok, { data: { exist: false } }]
    }
  },
  {
    method: 'POST',
    path: '/clients/2/verify-sms?phone=1234567890',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'POST',
    path: '/clients/2/verify-sms',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'POST',
    path: '/clients/movistar/verify/2',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'POST',
    path: '/clients/zone_u/verify/2',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'GET',
    path: '/clients/1988-09-26/credit',
    reply: async () => {
      await wait()
      return [status.ok, getCreditFromBirthday]
    }
  },
  {
    method: 'GET',
    path: '/client-editing-requests?limit=20&client=2',
    reply: async () => {
      await wait()
      return [status.ok, modificationHistoryPage1]
    }
  },
  {
    method: 'GET',
    path: '/payment-types/catalog',
    reply: async () => {
      await wait()
      return [status.ok, paymentTypes]
    }
  },
  {
    method: 'GET',
    path: '/wallet/12243434',
    reply: async () => {
      await wait()
      return [status.ok, wallet]
    }
  },
  {
    method: 'POST',
    path: '/transaction/search',
    reply: async () => {
      await wait()
      return [status.ok, transactionsPage1]
    }
  },
  {
    method: 'POST',
    path: '/payment/direct-recharge',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'POST',
    path: '/clients/2/update-email',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'POST',
    path: '/clients/2/update-phone',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'POST',
    path: '/user_client/2/create',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'POST',
    path: '/clients/2/lock',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'POST',
    path: '/clients/2/unlock',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'GET',
    path: '/user_client/2/activate',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'POST',
    path: '/payment/direct/recharge',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'POST',
    path: '/transaction/search/client',
    reply: async () => {
      await wait()
      return [status.ok, transactionSearchClient]
    }
  },
  {
    method: 'GET',
    path: '/clients/personal_information/2',
    reply: async () => {
      await wait()
      if (isCoordsOnlyLegacyLocationMock())
        return [
          status.ok,
          {
            data: {
              ...clientPersonalData.data,
              clientAddress: {
                ...clientPersonalData.data.clientAddress,
                lat: null,
                lng: null
              }
            }
          }
        ]
      if (isLegacyLocationMock())
        return [
          status.ok,
          {
            data: {
              ...clientPersonalData.data,
              clientAddress: {
                ...clientPersonalData.data.clientAddress,
                lat: null,
                lng: null,
                state: null,
                city: null,
                sectorId: null
              }
            }
          }
        ]
      return [status.ok, clientPersonalData]
    }
  },
  {
    method: 'POST',
    path: '/clients/personal_information/2',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'POST',
    path: '/clients/2/documents',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'GET',
    path: '/clients/2/documents',
    reply: async () => {
      await wait()
      return [status.ok, personalDocs]
    }
  },
  {
    method: 'POST',
    path: '/clients/2/documents/validate',
    reply: async () => {
      await wait()
      return [status.ok, { data: { valid: true } }]
    }
  },
  {
    method: 'GET',
    path: '/clients/2/activity-summary',
    reply: async () => {
      await wait()
      return [status.ok, activitySummary]
    }
  }
]
